import * as types from './mutation-types'

export default {
  setUserInfo(context, payload) {
    context.commit(types.SET_USER_INFO, payload)
  },
  updateCredit(context, payload) {
    context.commit(types.UPDATE_CREDIT, payload)
  },
  setXAuth(context, payload) {
    context.commit(types.SET_X_AUTH, payload)
  },
  enableJssdk(context) {
    context.commit(types.ENABLE_JSSDK)
  },
  disableJssdk(context) {
    context.commit(types.DISABLE_JSSDK)
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js